const LETTER_PATTERN = /[a-z]/i;

const normalizeSearchText = (value) => {
	return String(value || "")
		.trim()
		.toLowerCase()
		.replace(/\s+/g, " ");
};

const collectSearchValues = (candidate, searchValues, visited = new WeakSet()) => {
	if (typeof candidate === "string") {
		const normalizedValue = normalizeSearchText(candidate);
		if (normalizedValue && LETTER_PATTERN.test(normalizedValue)) {
			searchValues.add(normalizedValue);
		}
		return;
	}

	if (!candidate || typeof candidate !== "object") {
		return;
	}

	if (visited.has(candidate)) {
		return;
	}
	visited.add(candidate);

	if (Array.isArray(candidate)) {
		candidate.forEach((value) => {
			collectSearchValues(value, searchValues, visited);
		});
		return;
	}

	Object.values(candidate).forEach((value) => {
		collectSearchValues(value, searchValues, visited);
	});
};

export const buildDropdownSearchText = (option) => {
	const searchValues = new Set();
	collectSearchValues(option, searchValues);
	return Array.from(searchValues).join(" ");
};

export const getDropdownOptionSearchText = (option) => {
	const candidate = option?.data && typeof option.data === "object" ? option.data : option;
	if (typeof candidate?.searchText === "string") {
		return normalizeSearchText(candidate.searchText);
	}

	return buildDropdownSearchText(candidate);
};

export const matchesDropdownOptionSearch = (option, searchValue) => {
	const normalizedQuery = normalizeSearchText(searchValue);
	if (!normalizedQuery) {
		return true;
	}

	return getDropdownOptionSearchText(option).includes(normalizedQuery);
};

export const filterDropdownOption = (option, searchValue) => {
	return matchesDropdownOptionSearch(option, searchValue);
};
